import { Capacitor } from "@capacitor/core";

// Кнопка нативной камеры в Dashboard: скрытый <input type="file" capture>, который на
// телефоне открывает камеру сразу, без шага «выбрать файл → камера».
//
// Только на сенсорных устройствах. На компьютере браузер `capture` игнорирует, и кнопка
// «Сделать фотографию» открыла бы тот же выбор файлов, что и соседняя «выберите файлы».
// Права на камеру у приложений уже объявлены (AndroidManifest CAMERA, iOS
// NSCameraUsageDescription), подписи кнопок есть в @uppy/locales.

export function isTouchDevice({
  isNative = () => Capacitor.isNativePlatform(),
  env = typeof window !== "undefined" ? window : {},
} = {}) {
  if (isNative()) return true;
  if (typeof env.matchMedia !== "function") return false;
  return env.matchMedia("(pointer: coarse)").matches;
}

/**
 * Опции Dashboard для кнопок нативной камеры.
 *
 * @param {{ video?: boolean, photo?: boolean }} options video — ещё и кнопка записи видео;
 *   photo: false — фото-кнопку Uppy скрыть (её заменяет нативная камера, FT-186)
 * @param {boolean} touch сенсорное ли устройство (параметр — для тестов)
 * @returns {object} опции, которые разворачиваются в .use(Dashboard, { ... })
 */
export function nativeCameraOptions({ video = false, photo = true } = {}, touch = isTouchDevice()) {
  if (!touch) return {};

  return {
    // FT-186: в приложении при нативной камере фото-кнопку Uppy выключаем явно —
    // Dashboard.setOptions не снимет кнопку отсутствием ключа.
    showNativePhotoCameraButton: photo,
    showNativeVideoCameraButton: video,
    // Основная камера: снимают машину, повреждение, документ — не себя.
    nativeCameraFacingMode: "environment",
  };
}
